export const theme = {
  token: {
    colorSplit: '#E8E9EB', // Divider line (neutral-grey-4)
    colorPrimary: '#4E67EA',
    colorPrimaryHover: '#3E52BB',
    colorPrimaryActive: '#3E52BB',
    colorLink: '#4E67EA',
    colorLinkHover: '#3E52BB',
    colorLinkActive: '#3E52BB',
    // controlHeightLG: 40,
  },
  components: {
    Button: {
      borderRadius: 4,
      borderRadiusLG: 4,
      borderRadiusSM: 4,
      controlHeightLG: 40,
      controlHeightSM: 32,
      defaultActiveBorderColor: '#4E67EA',
      defaultActiveColor: '#4E67EA',
      borderColorDisabled: '#D9DADC',
      defaultBorderColor: '#D9DADC',
      defaultColor: '#252628',
      defaultHoverBorderColor: '#4E67EA',
      defaultHoverColor: '#4E67EA',
      paddingContentHorizontal: 13,
      paddingContentVertical: 4,

      colorError: '#F5222D',
      colorErrorHover: '#F5222D',
      colorErrorActive: '#F5222D',
      colorErrorBorder: '#F5222D',
    },
    Table: {
      colorBorderSecondary: '#E8E9EB',
    },
    Checkbox: {
      borderRadius: 4,
    },
    Input: {
      borderRadius: 8,
      controlHeightSM: 32,
    },
    Tag: {
      colorBorder: '#D9DADC',
      borderRadius: 4,
      borderRadiusLG: 4,
      borderRadiusSM: 4,
      colorText: '#434446',
      defaultBg: '#F7F8FA',
      fontSize: 12,
      lineHeight: 20,
    },
  },
};
